import { getAxiosInstance } from "../utils/apiClient";
import { getTokens } from "../utils/tokens";

const axiosInstance = getAxiosInstance();

export const getConversationsAPI = (query = {}) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .get("/api/messages/conversations", {
        params: query,
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.data || err));
  });
};

export const getMessagesAPI = (conversationId, query = {}) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .get(`/api/messages/conversation/${conversationId}`, {
        params: query,
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.data || err));
  });
};

export const sendMessageAPI = (data, files = []) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    const formData = new FormData();

    if (data.recipientId) {
      formData.append("recipientId", data.recipientId);
    }

    if (data.conversationId) {
      formData.append("conversationId", data.conversationId); // ✅ ДОДАЙ ЦЕ
    }

    formData.append("content", data.content || "");
    formData.append("type", data.type || "text");
    formData.append("isPaid", String(data.isPaid || false));
    formData.append("price", String(data.price || 0));

    // Add tipAmount for tip messages
    if (data.tipAmount !== undefined) {
      formData.append("tipAmount", String(data.tipAmount));
    }

    if (files.length > 0) {
      files.forEach((file) => {
        formData.append("files", file);
      });
    }

    axiosInstance
      .post("/api/messages", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => {
        return reject(err?.response?.data || err)
      });
  });
};

export const updateMessageStatusAPI = (messageId, status) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .patch(
        `/api/messages/${messageId}`,
        { status },
        {
          headers: {
            "Content-Type": "application/json",
            [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
            [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
              `Bearer ${tokens.firebase_token}`,
            "ngrok-skip-browser-warning": "true",
          },
        },
      )
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.data || err));
  });
};

export const deleteMessageAPI = (messageId) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .delete(`/api/messages/${messageId}`, {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.data || err));
  });
};

export const deleteConversationAPI = (conversationId) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .delete(`/api/messages/conversation/${conversationId}`, {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || err));
  });
};

export const createConversationAPI = (recipientId) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .post(
        "/api/messages/create-conversation",
        { recipientId },
        {
          headers: {
            "Content-Type": "application/json",
            [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
            [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
              `Bearer ${tokens.firebase_token}`,
            "ngrok-skip-browser-warning": "true",
          },
        },
      )
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.data || err));
  });
};
export const createGroupConversationAPI = ({
  participantIds,
  groupName = null,
}) => {
  const tokens = getTokens();
  return axiosInstance.post(
    "/api/messages/create-group-conversation",
    { participantIds, groupName },
    {
      headers: {
        "Content-Type": "application/json",
        [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
        [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
          `Bearer ${tokens.firebase_token}`,
        "ngrok-skip-browser-warning": "true",
      },
    },
  );
};

export const searchMessagesGloballyAPI = (query = {}) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .get("/api/messages/search/messages", {
        params: query,
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.data || err));
  });
};
export const getMyFollowersForChatAPI = () => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();

    axiosInstance
      .get("/api/messages/messages/my-followers", {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || err));
  });
};
